import { useEffect } from "react";
import api from "@/lib/api";
import SupplierDepositsLegacy from "./SupplierDepositsLegacy";

const today = () => new Date().toISOString().slice(0, 10);

export default function SupplierDeposits() {
  useEffect(() => {
    let busy = false;

    const currentSupplierId = () => document.querySelector("main.content section.panel select.field-input")?.value || "";

    const enhanceOpeningForm = () => {
      const headings = [...document.querySelectorAll("h2.panel-title")];
      const normalHeading = headings.find((h) => h.textContent?.trim() === "Tambah Deposit");
      const normalSection = normalHeading?.closest("section.panel");
      if (!normalSection || document.querySelector('[data-opening-deposit-form="1"]')) return;

      const section = document.createElement("section");
      section.className = "panel";
      section.dataset.openingDepositForm = "1";
      section.innerHTML = `
        <h2 class="panel-title">Saldo Awal Deposit Supplier</h2>
        <p class="hint">Khusus saldo Deposit yang sudah berada di Supplier sebelum cut-off ERP. Tidak membuat BANK OUT dan tidak membuat FundEntry keluar.</p>
        <div class="form-grid">
          <div><label class="field-label">Tanggal Saldo Awal / Cut-off</label><input class="field-input" type="date" data-opening-date="1" value="${today()}" /></div>
          <div><label class="field-label">Nominal Saldo Awal</label><input class="field-input" type="number" min="1" step="1" data-opening-amount="1" /></div>
          <div><label class="field-label">Referensi</label><input class="field-input" data-opening-reference="1" placeholder="Opsional" /></div>
          <div><label class="field-label">Catatan</label><input class="field-input" data-opening-note="1" placeholder="Opsional" /></div>
        </div>
        <div class="form-actions"><button class="btn-primary" type="button" data-opening-submit="1">Catat Saldo Awal</button></div>
      `;
      normalSection.insertAdjacentElement("afterend", section);

      const btn = section.querySelector('[data-opening-submit="1"]');
      btn.onclick = async () => {
        const supplierId = currentSupplierId();
        const openingDate = section.querySelector('[data-opening-date="1"]')?.value;
        const amount = Number(section.querySelector('[data-opening-amount="1"]')?.value || 0);
        const reference = section.querySelector('[data-opening-reference="1"]')?.value?.trim() || null;
        const note = section.querySelector('[data-opening-note="1"]')?.value?.trim() || null;
        if (!supplierId) return window.alert("Pilih Supplier terlebih dahulu.");
        if (!openingDate) return window.alert("Tanggal Saldo Awal wajib diisi.");
        if (amount <= 0) return window.alert("Nominal Saldo Awal harus lebih dari 0.");
        if (!window.confirm("Catat sebagai Saldo Awal Deposit Supplier tanpa BANK OUT?")) return;
        btn.disabled = true;
        try {
          await api.post("/supplier-deposits/opening", {
            supplier_id: supplierId,
            amount,
            opening_date: openingDate,
            reference,
            note,
            idempotency_key: `SUPOPEN-${supplierId.slice(0, 8)}-${Date.now()}`,
          });
          window.location.reload();
        } catch (e) {
          window.alert(e?.response?.data?.detail || "Saldo Awal Deposit Supplier gagal dicatat.");
          btn.disabled = false;
        }
      };
    };

    const enhanceHistory = async () => {
      if (busy) return;
      const headings = [...document.querySelectorAll("h2.panel-title")];
      const heading = headings.find((h) => h.textContent?.trim() === "Riwayat Deposit");
      const table = heading?.closest("section")?.querySelector("table");
      const supplierId = currentSupplierId();
      if (!table || !supplierId || table.dataset.depositReverseEnhanced === supplierId) return;
      busy = true;
      try {
        const { data } = await api.get(`/supplier-deposits?supplier_id=${supplierId}`);
        const deposits = Array.isArray(data) ? data : [];
        const headRow = table.querySelector("thead tr");
        if (headRow && !headRow.querySelector('[data-source-col="1"]')) {
          const sourceTh = document.createElement("th"); sourceTh.textContent = "Jenis"; sourceTh.dataset.sourceCol = "1"; headRow.appendChild(sourceTh);
          const actionTh = document.createElement("th"); actionTh.textContent = "Aksi"; actionTh.dataset.reverseCol = "1"; headRow.appendChild(actionTh);
        }
        const rows = [...table.querySelectorAll("tbody tr")];
        rows.forEach((tr, idx) => {
          if (tr.querySelector('[data-reverse-cell="1"]')) return;
          const dep = deposits[idx];
          const sourceTd = document.createElement("td"); sourceTd.dataset.sourceCell = "1";
          sourceTd.textContent = dep?.source_kind === "OPENING" ? "Saldo Awal" : "BANK OUT";
          tr.appendChild(sourceTd);

          const td = document.createElement("td"); td.dataset.reverseCell = "1";
          if (dep?.status === "POSTED") {
            const btn = document.createElement("button"); btn.className = "btn-mini"; btn.textContent = "Reverse";
            btn.onclick = async () => {
              const isOpening = dep.source_kind === "OPENING";
              const reason = window.prompt(isOpening ? "Alasan koreksi Saldo Awal Deposit ini:" : "Alasan membatalkan Deposit ini:");
              if (!reason?.trim()) return;
              const confirmText = isOpening
                ? "Saldo Awal akan dibalik tanpa BANK IN/FundEntry. Reversal hanya diizinkan bila saldo deposit masih tersedia. Lanjut?"
                : "Deposit akan dikembalikan ke BANK dan MODAL dipulihkan. Reversal hanya diizinkan bila saldo deposit masih tersedia. Lanjut?";
              if (!window.confirm(confirmText)) return;
              btn.disabled = true;
              try {
                await api.post(`/supplier-deposits/${dep.id}/reverse`, { reason: reason.trim() });
                window.location.reload();
              } catch (e) {
                window.alert(e?.response?.data?.detail || "Reversal Supplier Deposit gagal.");
                btn.disabled = false;
              }
            };
            td.appendChild(btn);
          } else td.textContent = "-";
          tr.appendChild(td);
        });
        table.dataset.depositReverseEnhanced = supplierId;
      } finally { busy = false; }
    };

    const enhance = () => {
      enhanceOpeningForm();
      enhanceHistory().catch(() => {});
    };
    const obs = new MutationObserver(enhance); obs.observe(document.body, { childList: true, subtree: true });
    document.addEventListener("change", enhance, true); enhance();
    return () => { obs.disconnect(); document.removeEventListener("change", enhance, true); };
  }, []);
  return <SupplierDepositsLegacy />;
}
